<fate-input customClass="form-control" [uiId]="uiId" [row]="row" [placeholder]="placeholder" [ngModel]="passthrough" (ngModelChange)="onChange($event)"></fate-input>
<fate-ui [uiId]="uiId" [buttons]="buttons" [ngClass]="{'visible': uiVisible}" class="tooltip tooltip-inner"></fate-ui>
